import React from 'react';
import PropTypes from 'prop-types';
import { BackgroundColorContainer } from '../../atoms';
import { Carousel } from '../../molecules';
import { PressLogo } from './PressLogo';
import {
  StyledPressLogos,
  MobilePressLogoContainer,
  PressLogoContainer,
  LogoWrapper,
} from './styles.js';

export const PressLogos = ({ publications }) => {
  const renderPublication = ({ src, quote, alt, width, height }) => (
    <LogoWrapper count={publications.length} key={src}>
      <PressLogo
        quote={quote}
        src={src}
        alt={alt}
        width={width}
        height={height}
      />
    </LogoWrapper>
  );

  return (
    <BackgroundColorContainer bgColor="secondary.kale">
      <StyledPressLogos>
        <MobilePressLogoContainer>
          <Carousel dotPadding={6} dotVariant="bone" showArrows={false}>
            {publications.map(renderPublication)}
          </Carousel>
        </MobilePressLogoContainer>
        <PressLogoContainer>
          {publications.map(renderPublication)}
        </PressLogoContainer>
      </StyledPressLogos>
    </BackgroundColorContainer>
  );
};

PressLogos.displayName = 'PressLogos';

PressLogos.propTypes = {
  publications: PropTypes.arrayOf(
    PropTypes.shape({
      src: PropTypes.string.isRequired,
      alt: PropTypes.string.isRequired,
      quote: PropTypes.string,
      width: PropTypes.number,
      height: PropTypes.number,
    }),
  ).isRequired,
};
